const DEFAULT_MAX_BUTTONS = 6;

type VisiblePagesParams = {
  currentPage: number;
  totalPages: number;
  maxButtons?: number;
};

export const getVisiblePages = ({ currentPage, totalPages, maxButtons = DEFAULT_MAX_BUTTONS }: VisiblePagesParams) => {
  if (totalPages <= maxButtons) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, 4, '...', totalPages];
  }

  if (currentPage >= totalPages - 2) {
    return [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }

  return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
};
